import STModal from "../st-modal/st-modal";
import STInput from "../st-input/st-input";
import STButton, { ButtonType } from "../st-button/st-button";
import { Accessor, Setter, Show, createEffect, createMemo, createSignal } from "solid-js";
import { requireReportBrowser } from "./report-browser-context";
import STCheckbox from "../st-checkbox/st-checkbox";

export default function PublishDialog() {
    const reportBrowser = requireReportBrowser()!

    const [padLocation, setPadLocation] = createSignal('')
    const [isOpen, setIsOpen] = createSignal(reportBrowser.state.isPublishDialogOpen)
    const publishPlaceholder = (window as any).ST?.LocaleDistrict ? `Root (${(window as any).ST.LocaleDistrict})` : 'Root'

    createEffect(() => { setIsOpen(reportBrowser.state.isPublishDialogOpen) })

    createEffect(() => {
        if (isOpen() !== reportBrowser.state.isPublishDialogOpen) {
            if (isOpen() === false) {
                reportBrowser.cancelPublish()
            }
        }
    })

    const [publishToPad, setPublishToPad] = createSignal(true)
    const [overrideDefault, setOverrideDefault] = createSignal(false)

    const publish = () => {
        if (!canPublish()) return

        reportBrowser.publishReport(reportBrowser.selectedReport()!, padLocation(), publishToPad(), overrideDefault())
    }

    const canPublish = () => publishToPad() || overrideDefault()

    const canOverrideDefault = () => {
        const selectedReport = reportBrowser.selectedReport()
        if (!selectedReport) return false
        if (!selectedReport.parentReportGU) return false

        const parentReport = reportBrowser.allReports().find(r => r.reportGU === selectedReport.parentReportGU)
        if (!parentReport) return false
        if (!parentReport.isPublished) return false

        return true
    }

    return (
        <Show when={reportBrowser.selectedReport()}>
            <STModal show={[isOpen, setIsOpen]}>
                <div style="display: flex; flex-direction: column; gap: 8px;">
                    <div style="font-size: 16px; font-weight: bold;">
                        Publish ({reportBrowser.selectedReport()!.number} - {reportBrowser.selectedReport()!.name})
                    </div>
                    <div>
                        <STCheckbox label="Publish To PAD Tree" value={[publishToPad, setPublishToPad]}></STCheckbox>
                    </div>
                    <Show when={publishToPad()}>
                        <div style="display: flex; flex-direction: column; gap: 2px;">
                            <span>Location in PAD</span>
                            <STInput value={[padLocation, setPadLocation]} placeholder={publishPlaceholder}></STInput>
                        </div>
                    </Show>
                    <Show when={canOverrideDefault()}>
                        <div>
                            <STCheckbox label={`Override default report (${reportBrowser.selectedReport()!.parentReport})`} value={[overrideDefault, setOverrideDefault]}></STCheckbox>
                        </div>
                    </Show>
                    <div style="align-self: stretch; display: flex; justify-content: end; gap: 8px;">
                        <STButton enabled={!reportBrowser.state.isPublishing} onClick={() => reportBrowser.cancelCopy()}>Cancel</STButton>
                        <STButton enabled={canPublish()} loading={reportBrowser.state.isPublishing} onClick={publish} type="primary">
                            Publish
                        </STButton>
                    </div>
                </div>
            </STModal>
        </Show>
    )
}